import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  MapEntityEditorViewState,
  setCopyStopIdAction,
  setRouteMetadataFormOpenAction,
  useAppAction,
  useAppDispatch,
} from '../../../redux';
import { useMapViewState } from '../Utils/useMapViewState';
import { FloatingFooter } from './FloatingFooter';

type FloatingAddModeFooterProps = {
  readonly isInDrawingMode: boolean;
  readonly onCancel: () => void;
};

export const FloatingAddModeFooter: FC<FloatingAddModeFooterProps> = ({
  isInDrawingMode,
  onCancel,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [mapViewState, setMapViewState] = useMapViewState();
  const setCopyStopId = useAppAction(setCopyStopIdAction);

  const onCancelAddMode = () => {
    setMapViewState({
      stops: MapEntityEditorViewState.NONE,
      stopAreas: MapEntityEditorViewState.NONE,
      terminals: MapEntityEditorViewState.NONE,
      depotStops: MapEntityEditorViewState.NONE,
    });

    // Reset copy stop mode
    setCopyStopId(undefined);
  };

  const onCancelDrawMode = () => {
    // Close metadata modal and stop route creation (same behavior as route cancel).
    dispatch(setRouteMetadataFormOpenAction(false));
    onCancel();
  };

  const onClose = () => {
    if (isInDrawingMode) {
      onCancelDrawMode();
    } else {
      onCancelAddMode();
    }
  };

  const getAddModeText = () => {
    if (isInDrawingMode) {
      return t(($) => $.map.drawRoute);
    }
    if (mapViewState.stops === MapEntityEditorViewState.PLACE) {
      return t(($) => $.map.addStop);
    }
    if (mapViewState.stops === MapEntityEditorViewState.PLACECOPY) {
      return t(($) => $.map.copyStop);
    }
    if (mapViewState.depotStops === MapEntityEditorViewState.PLACE) {
      return t(($) => $.map.addDepotStop);
    }
    if (mapViewState.stopAreas === MapEntityEditorViewState.PLACE) {
      return t(($) => $.map.createNewStopArea);
    }
    if (mapViewState.terminals === MapEntityEditorViewState.PLACE) {
      return t(($) => $.map.createNewTerminal);
    }
    return '';
  };

  return (
    <FloatingFooter onClose={onClose} testId="MapFooter">
      {getAddModeText()}
    </FloatingFooter>
  );
};
